import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/rocketchat': {
    width: 582,
    height: 512,
    paths: [
      {
        d: 'M491.9 105.9C414.1 54.5 310.7 42.8 224.8 58.3 128.7-34.4 21 8.2 0 20.5 0 20.5 73.9 83.3 61.9 138.3-25.6 227.5 16 326.8 61.9 373.7 73.9 428.7 0 491.5 0 491.5 20.8 503.8 128.2 546.3 224.8 454.1 310.5 469.5 413.9 457.9 491.9 406.4 612.5 329.4 612.9 183.3 491.9 105.9zM297.5 405.9C267.4 406 237.5 402.1 208.4 394.4L188.4 413.7C177.3 424.5 164.8 433.8 151.4 441.4 135.1 449.6 117.3 454.7 99.1 456.3 100.1 454.5 101 452.7 101.9 451 121.9 413.9 127.3 380.7 118.1 351.2 85.2 325.3 65.5 292.2 65.5 256 65.5 173.1 169.4 105.9 297.5 105.9S529.5 173.1 529.5 256C529.5 338.9 425.6 405.9 297.5 405.9zM186.2 291.7C167.1 292 151.3 276.7 151 257.6 150.3 211.7 219.6 210.7 220.3 256.5V257C220.5 276.3 204.8 291.7 186.2 291.7zM260.8 257.6C260 211.7 329.3 210.6 330.1 256.4V257C330.5 302.6 261.6 303.1 260.8 257.6zM405.8 291.7C386.7 292 370.9 276.7 370.6 257.6 369.9 211.7 439.2 210.7 439.9 256.5V257C440.1 276 424.9 291.6 405.8 291.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/rocketchat.js
// module id = T2ms
// module chunks = 144